import { render, staticRenderFns } from "./UseRule.vue?vue&type=template&id=c207b502&scoped=true&"
import script from "./use-rule.js?vue&type=script&lang=js&"
export * from "./use-rule.js?vue&type=script&lang=js&"
import style0 from "./use-rule.scss?vue&type=style&index=0&id=c207b502&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c207b502",
  null
  
)

export default component.exports